export default __webpack_public_path__ + "static/media/icon-learning-time.0f432130.svg";